module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Order Info","pleaseEnterCompanyName":"Please enter company name"},"zh-tw":{"title":"訂單資訊","pleaseEnterCompanyName":"請輸入收據抬頭"}}')
  delete Component.options._Ctor
}
